// extracted by mini-css-extract-plugin
export default {"result":"crCd8","copy":"_3M-EM","input":"YmvgO"};